import { render, staticRenderFns } from "./PlayingFieldsPage.vue?vue&type=template&id=c994c818&"
import script from "./PlayingFieldsPage.vue?vue&type=script&lang=js&"
export * from "./PlayingFieldsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports